'use client';

import { useEffect } from 'react';
import { scrollToHashWithSettle } from '@/lib/utils/scroll-to-hash';

/**
 * When the homepage is opened directly at a "/#hash" (e.g. navigating from another
 * page via the navbar), Next performs the initial anchor jump before the deferred
 * sections settle, so it lands off-target. This re-runs the resilient scroll once the
 * page has mounted. Renders nothing.
 */
export function HashScrollOnLoad() {
  useEffect(() => {
    let raf = 0;

    const runHashScroll = () => {
      const hash = window.location.hash;
      if (!hash) return;
      cancelAnimationFrame(raf);
      // Defer to the next frame so the eager/deferred wrappers are in the DOM.
      raf = requestAnimationFrame(() => scrollToHashWithSettle(hash, { maxSettleMs: 6000 }));
    };

    runHashScroll();
    window.addEventListener('hashchange', runHashScroll);

    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener('hashchange', runHashScroll);
    };
  }, []);

  return null;
}

export default HashScrollOnLoad;
